module.exports = __webpack_public_path__ + "static/media/What_to_Do_in_an_Emergency.c1c306ed.png";